﻿(function () {

    'use strict';
    var serviceId = 'repository.containerreception';
    angular
        .module('app.services')
        .factory(serviceId, containerreception);

    containerreception.$inject = ['common', 'repository.abstract', '$http'];

    function containerreception(common, abstractRepository, $http) {
        var config = common.config;

        function Ctor(mgr) {
            this.manager = mgr;
            this.getFilters = getFilters;
            this.getActivityTypes = getActivityTypes;
            this.getCarrierList = getCarrierList;
            this.getCarrierByNameUrl = getCarrierByNameUrl;
            this.getDateTypes = getDateTypes;
            this.getContainerReceptionList = getContainerReceptionList;
        }

        abstractRepository.extend(Ctor);
        return Ctor;

        function getFilters() {
            var authData = common.localStorageService.get('authorizationData');
            var codeRole = authData ? authData.userRole : "";
            return common.httpGet(config.basePaths.Base_Path_Resources + 'reportList/GetContainerReceptionFilters?codeRole=' + codeRole);
        }

        function getActivityTypes() {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'equipment/GetActivityTypesGTIGTO');
        }

        function getCarrierList() {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'reportList/GetCarrierList');
        }

        function getCarrierByNameUrl() {
            return config.basePaths.Base_Path_Resources + 'reportList/GetCarrierByName';
        }

        function getDateTypes() {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'reportList/GetDateTypes');
        }

        function getContainerReceptionList(model) {
            return common.httpPost(config.basePaths.Base_Path_Resources + 'reportList/GetContainerReceptionList', model);
        }
    }

})();
